import React from 'react';
import { SvgProps } from './icon.props';

const HealthSvg: React.FC<SvgProps> = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.2" cx="20" cy="20" r="20" fill="#FF7A96" />
      <g clipPath="url(#clip0_5419_8762)">
        <path
          d="M31.6857 16.31C31.6287 16.2226 31.5392 16.1615 31.4371 16.1403L28.0088 15.4302L27.9002 15.4088L27.8501 15.3989C27.0727 13.4759 25.2067 12.2167 23.1324 12.2154H16.8657C14.7899 12.2075 12.9203 13.4699 12.1522 15.3985L12.0979 15.4088L8.56214 16.1403C8.46002 16.1615 8.37071 16.2226 8.31371 16.31C8.25672 16.3972 8.23683 16.5037 8.25863 16.6056L10.6087 27.5724C10.6309 27.6763 10.6943 27.7668 10.7844 27.8228C10.8745 27.879 10.9835 27.8962 11.0866 27.8706L11.2006 27.8423C18.9313 25.8237 21.0706 25.8241 28.8042 27.8423L28.9138 27.8698C29.0169 27.8955 29.1259 27.8783 29.216 27.822C29.3061 27.766 29.3696 27.6755 29.3917 27.5717L31.7418 16.6049C31.763 16.5031 31.7429 16.397 31.6857 16.31ZM13.8172 14.2588C14.6245 13.4487 15.722 12.9949 16.8657 12.9987H23.1324C24.7001 12.9993 26.1442 13.8503 26.9042 15.2216C26.8807 15.2172 26.8571 15.2145 26.8332 15.2105C26.3308 15.1215 25.8279 15.0445 25.3243 14.9756C25.2373 14.9634 25.1503 14.9513 25.0638 14.9399C24.5653 14.8754 24.0663 14.82 23.5668 14.7739L23.3153 14.7523C22.8062 14.7088 22.2971 14.674 21.7878 14.6509C21.7295 14.648 21.6704 14.6465 21.6128 14.6442C20.5324 14.5994 19.4525 14.5994 18.3725 14.6442C18.3218 14.6442 18.2717 14.6473 18.2216 14.6497C17.7028 14.6731 17.1841 14.7088 16.6658 14.753C16.5935 14.7593 16.521 14.7653 16.4486 14.7719C15.9393 14.818 15.4302 14.8745 14.9211 14.941L14.6924 14.972C14.1817 15.0418 13.6726 15.1212 13.1647 15.2101C13.1417 15.2145 13.119 15.2168 13.0958 15.2212C13.2901 14.8681 13.533 14.5444 13.8172 14.2588ZM28.7098 27.0096C21.1314 25.0451 18.864 25.0455 11.2882 27.0096L11.1315 26.2819L11.2335 26.2557C19.0147 24.2342 20.9809 24.2339 28.7631 26.2557L28.8649 26.2819L28.7098 27.0096ZM29.0303 25.5154L28.9609 25.4974C21.0882 23.4517 18.9097 23.4517 11.0373 25.4974L10.9678 25.5154L9.10624 16.8273L12.1386 16.2008L12.2526 16.178C12.3331 16.1615 12.4152 16.1451 12.5079 16.1298C13.5642 15.921 14.6231 15.7574 15.6851 15.6394C19.6265 15.1933 23.613 15.3595 27.5036 16.1321C27.5818 16.1451 27.6648 16.1615 27.7455 16.178L30.8919 16.8286L29.0303 25.5154Z"
          fill="#FF7A96"
        />
        <path
          d="M19.6075 14.1735H20.3908C20.6071 14.1735 20.7825 13.9981 20.7825 13.7818C20.7825 13.5655 20.6071 13.3901 20.3908 13.3901H19.6075C19.3912 13.3901 19.2158 13.5655 19.2158 13.7818C19.2158 13.9981 19.3912 14.1735 19.6075 14.1735Z"
          fill="#FF7A96"
        />
        <path
          d="M21.5655 14.1735H22.3488C22.5651 14.1735 22.7405 13.9981 22.7405 13.7818C22.7405 13.5655 22.5651 13.3901 22.3488 13.3901H21.5655C21.3492 13.3901 21.1738 13.5655 21.1738 13.7818C21.1738 13.9981 21.3492 14.1735 21.5655 14.1735Z"
          fill="#FF7A96"
        />
        <path
          d="M17.6485 14.1735H18.4319C18.6482 14.1735 18.8235 13.9981 18.8235 13.7818C18.8235 13.5655 18.6482 13.3901 18.4319 13.3901H17.6485C17.4322 13.3901 17.2568 13.5655 17.2568 13.7818C17.2568 13.9981 17.4322 14.1735 17.6485 14.1735Z"
          fill="#FF7A96"
        />
        <path
          d="M21.1736 16.5237H18.8236V18.482H16.8652V20.8321H18.8236V22.7904H21.1736V20.8321H23.132V18.482H21.1736V16.5237ZM22.3486 19.2654V20.0487H20.3903V22.0071H19.6069V20.0487H17.6486V19.2654H19.6069V17.307H20.3903V19.2654H22.3486Z"
          fill="#FF7A96"
        />
      </g>
      <defs>
        <clipPath id="clip0_5419_8762">
          <rect
            width="23.5"
            height="23.5"
            fill="white"
            transform="translate(8.25 8.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HealthSvg;
